module.exports = __webpack_public_path__ + "static/media/battleships-ready-go.e02fda39.jpg";